import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      location: 'Mumbai',
      rating: 5,
      text: 'Excellent service! Booked an appointment easily and the doctor was very professional. The video consultation feature saved me so much time.',
      date: '2 weeks ago'
    },
    {
      id: 2,
      name: 'Rajesh Kumar',
      location: 'Delhi',
      rating: 5,
      text: 'Very impressed with the platform. Found a great specialist near me and got an appointment within 2 days. Highly recommended!',
      date: '1 month ago'
    },
    {
      id: 3,
      name: 'Anita Desai',
      location: 'Bangalore',
      rating: 5,
      text: 'The app is user-friendly and maintains complete history of visits. Makes healthcare management so much easier. Thank you GEWO Health!',
      date: '3 weeks ago'
    },
    {
      id: 4,
      name: 'Vikram Patel',
      location: 'Pune',
      rating: 5,
      text: 'Quick response from doctors and easy rescheduling options. The digital prescription feature is very convenient. Great experience overall.',
      date: '1 week ago'
    }
  ];

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title}>What Our Patients Say</h2>
          <p style={styles.subtitle}>
            Real feedback from thousands of satisfied patients across the country
          </p>
        </div>

        <div style={styles.grid}>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              style={styles.card}
              className="hover-lift"
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(40, 108, 255, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.04)';
              }}
            >
              <div style={styles.quoteIcon}>
                <Quote size={24} style={{ color: '#286CFF', opacity: 0.3 }} />
              </div>
              
              <div style={styles.rating}>
                {[...Array(testimonial.rating)].map((_, index) => (
                  <Star
                    key={index}
                    size={16}
                    fill="#FFD28A"
                    stroke="#FFD28A"
                  />
                ))}
              </div>

              <p style={styles.text}>{testimonial.text}</p>

              <div style={styles.author}>
                <div style={styles.avatar}>
                  {testimonial.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <div style={styles.name}>{testimonial.name}</div>
                  <div style={styles.location}>{testimonial.location} • {testimonial.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: '#F4F7FB'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px'
  },
  header: {
    textAlign: 'center',
    marginBottom: '64px'
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    lineHeight: '1.2',
    color: '#4A4A4A',
    marginBottom: '16px'
  },
  subtitle: {
    fontSize: '18px',
    color: '#7C8A9A',
    maxWidth: '600px',
    margin: '0 auto'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '32px',
    position: 'relative',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E8ECF0'
  },
  quoteIcon: {
    position: 'absolute',
    top: '20px',
    right: '20px'
  },
  rating: {
    display: 'flex',
    gap: '4px',
    marginBottom: '16px'
  },
  text: {
    fontSize: '15px',
    lineHeight: '1.6',
    color: '#4A4A4A',
    marginBottom: '24px'
  },
  author: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  avatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #286CFF 0%, #133E97 100%)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: '600'
  },
  name: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#4A4A4A',
    marginBottom: '2px'
  },
  location: {
    fontSize: '13px',
    color: '#7C8A9A'
  }
};

export default Testimonials;